module.exports = __webpack_public_path__ + "static/media/invitedFriends_250_500.dd270f57.png";